import { OverviewView } from './Overview'

/**
 * /info opens on the CADINUdex overview (tiles, charts, tables, feed). Total differs from the CADINUdex tab in one card: the
 * MultiSwap activity at the end counts trades through our app on every DEX, not only on CADINUdex pools.
 */
export const TotalView: React.FC = () => <OverviewView marketDex="cadinu" activityScope="total" version="all" />
export default TotalView
